import React, { useEffect, useState } from 'react';
import ConfirmModal from '../SprintDetail/FlowchartView/components/ConfirmModal';
import './DeleteFoldersModal.css';

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

const folderBit = (info) =>
  info.names.length === 1
    ? `"${info.names[0]}"`
    : plural(info.names.length, 'folder', 'folders');

const buildMessage = (info, cascade) => {
  if (cascade) {
    const sub = info.cascadeSubfolderCount;
    const docs = info.cascadeDocCount;
    const head =
      sub > 0
        ? `Delete ${folderBit(info)} and ${plural(sub, 'subfolder', 'subfolders')}?`
        : `Delete ${folderBit(info)}?`;
    const docBit =
      docs > 0
        ? `${plural(docs, 'doc', 'docs')} will move to ${info.destinationLabel}.`
        : 'Those folders have no docs.';
    return `${head}\n${docBit}`;
  }

  const parts = [];
  if (info.dissolveChildFolderCount > 0) {
    parts.push(plural(info.dissolveChildFolderCount, 'subfolder', 'subfolders'));
  }
  if (info.dissolveDocCount > 0) {
    parts.push(plural(info.dissolveDocCount, 'doc', 'docs'));
  }
  const move = parts.length
    ? `${parts.join(' and ')} will move to ${info.destinationLabel}.`
    : 'Nothing else is inside.';
  return `Delete ${folderBit(info)}?\n${move}`;
};

/**
 * Confirm deleting folders. Nested folders go with them unless the user
 * unchecks the box; docs always move to the leftover parent.
 */
const DeleteFoldersModal = ({ isOpen, info, onConfirm, onCancel }) => {
  const [cascade, setCascade] = useState(true);

  useEffect(() => {
    if (isOpen) setCascade(true);
  }, [isOpen]);

  if (!info) return null;

  const removingSeveral =
    (cascade ? info.topmostIds.length + info.cascadeSubfolderCount : info.topmostIds.length) >
    1;

  return (
    <ConfirmModal
      isOpen={isOpen}
      title={removingSeveral ? 'Delete folders' : 'Delete folder'}
      message={buildMessage(info, cascade)}
      confirmLabel={removingSeveral ? 'Delete folders' : 'Delete folder'}
      cancelLabel="Cancel"
      confirmVariant="danger"
      icon="📁"
      onConfirm={() => onConfirm(cascade)}
      onCancel={onCancel}
    >
      {info.cascadeSubfolderCount > 0 && (
        <label className="delete-folders-modal__check">
          <input
            type="checkbox"
            checked={cascade}
            onChange={(e) => setCascade(e.target.checked)}
            onKeyDown={(e) => e.stopPropagation()}
          />
          Also delete {plural(info.cascadeSubfolderCount, 'subfolder', 'subfolders')}
        </label>
      )}
    </ConfirmModal>
  );
};

export default DeleteFoldersModal;
